import "./Validation.scss";
import React, {useEffect, useState, useContext, Fragment} from "react";
import {
    Col,
    Row,
    Icon,
    Radio,
    Checkbox,
    Button,
    Form,
    InputNumber,
    Select,
    Input,
    Divider
} from "antd";

import {useTranslation} from "react-i18next";
import {globalContext} from "../../../../../../contexts";

const Validation = ({component, fields, field, handleClickSelect, closeModalHandler, lang}) => {
    const {t} = useTranslation(['forms', 'translations'])
    const {datasources, currentUser} = useContext(globalContext)
    const [selectedValue, setSelectedValue] = useState(field.validation?.type ?? null)
    const [decimals, setDecimals] = useState(field.validation ? field.validation.decimals : null)
    const [maxLength, setMaxLength] = useState(field.validation ? field.validation.maxLength : null)
    const [fieldConditionId, setFieldConditionId] = useState(field.validation?.fieldConditionId ?? null)
    const [fieldCondition, setFieldCondition] = useState(null)
    const [fieldConditionValue, setFieldConditionValue] = useState(field.validation?.fieldConditionValue ?? null)
    const [fieldPrefilledId, setFieldPrefilledId] = useState(field.validation?.fieldPrefilledId ?? null)
    const [fieldPrefilled, setFieldPrefilled] = useState(null)
    const [fieldPrefilledValue, setFieldPrefilledValue] = useState(field.validation?.fieldPrefilledValue ?? null)
    const [fieldPrefilledOption, setFieldPrefilledOption] = useState(field.validation?.fieldPrefilledOption ?? null)

    const [acceptedFormats, setAcceptedFormats] = useState(field.validation?.acceptedFormats || []);
    const [maxSize, setMaxSize] = useState(field.validation?.maxSize ?? null);


    useEffect(() => {
        if (field.validation?.fieldConditionId) {
            handleChangeFieldCondition(field.validation?.fieldConditionId, false)
        }
        if (field.validation?.fieldPrefilledId) {
            handleChangeFieldPrefilled(field.validation?.fieldPrefilledId, false)
        }
    }, [])

    const handleChangeValidation = (type) => {
        setSelectedValue(type)
        if (type && (type === 'percent' | type.startsWith('rut'))) {
            setMaxLength(null)
            setDecimals(null)
        } else if (type !== 'number' && type !== 'percent') {
            setDecimals(null)
        }
    }

    const handleClickSelectValidation = () => {
        let validation = {}

        if (field.typeField === "FILE") {
            validation = {
                acceptedFormats,
                maxSize
            }
        } else {
            validation = {
                type: selectedValue,
                decimals,
                maxLength,
                fieldConditionId,
                fieldConditionValue,
                fieldPrefilledId,
                fieldPrefilledValue,
                fieldPrefilledOption
            }
        }

        handleClickSelect(validation)
    }

    const handleChangeDecimals = (val) => {
        setDecimals(val)
    }

    const handleChangeMaxLength = (val) => {
        setMaxLength(val)
    }

    const handleChangeFieldCondition = (id, resetValue) => {
        setFieldConditionId(id)
        const f = fields.filter(f => f.id === id)
        setFieldCondition(f[0])
        if (resetValue) setFieldConditionValue(undefined)
    }

    const handleChangeValueCondition = (val) => {
        setFieldConditionValue(val)
    }

    const handleChangeFieldPrefilled = (id, resetValue) => {
        setFieldPrefilledId(id)
        const f = fields.filter(f => f.id === id)
        setFieldPrefilled(f[0])
        if (resetValue) setFieldPrefilledValue(undefined)
    }

    const handleChangeValuePrefilled = (val) => {
        setFieldPrefilledValue(val)
    }

    const handleChangeOptionPrefilled = (val) => {
        setFieldPrefilledOption(val)
    }

    const getValuesFromDS = (field) => {
        if (datasources && field.source && field.source.indexOf(':') > 0) {
            let ds = field.source.split(':')
            if (datasources[ds[0]] && datasources[ds[0]][ds[1]]) {
                let datasource = datasources[ds[0]][ds[1]]
                if (datasource.parent) {
                    if (datasources[ds[0]][datasource.parent]) {
                        const values = datasources[ds[0]][datasource.parent].values
                        if (datasource.parent === "COUNTRIES") {
                            let countryCode = ""
                            if (currentUser?.cliente) {
                                countryCode = currentUser.cliente.pais === "CHI" ? "CL" : currentUser.cliente.pais === "PER" ? "PE" : ""
                            }
                            const parValue = values.find(v => v.code === countryCode)
                            return datasource.values.filter(v => v.parent == parValue?.code)
                        }
                    }
                }
                return datasource.values
            }
        }
        return [{code: 'no-data', value: {es: "No hay datos", en: "No data", pt: "No dados"}}]
    }

    return (
        <Row className="validation-edit">
            <Divider orientation="left">{t('messages.aml.validation', {ns: 'translations'})}</Divider>

            {field.typeField === "FILE" ?
            <>
                <Row>
                    <Form.Item label={t('forms.manager.validation.acceptedFormats')}>
                        <Select
                            mode="multiple"
                            style={{width: '100%'}}
                            placeholder={t('forms.manager.validation.selectFormats')}
                            value={acceptedFormats}
                            onChange={(formats) => setAcceptedFormats(formats)}
                        >
                            {[".png", ".jpg", ".jpeg", ".pdf", ".doc", ".docx", ".xls", ".xlsx"].map(format => (
                                <Select.Option key={format} value={format}>{format}</Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Row>
                <Row>
                    <Col span={12}>
                        <Form.Item label={t('forms.manager.validation.maxSizeKB')}>
                            <InputNumber
                                min={0}
                                max={5000}
                                value={maxSize}
                                onChange={setMaxSize}
                                style={{width: '80%'}}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </>
            :
            <>
                <Row>
                    <Form.Item label={t('forms.manager.validation.selectType')}>
                        <Select value={selectedValue} onChange={handleChangeValidation} style={{width: '98%'}}>
                            <Select.Option value={null}>
                                <Icon size="small" type="font-colors" className="icon-select-type-validation"/>
                                {t('forms.manager.validation.freeText')}
                            </Select.Option>
                            <Select.Option value="email">
                                <Icon size="small" type="mail" className="icon-select-type-validation"/>
                                {t('forms.manager.validation.email')}
                            </Select.Option>
                            <Select.Option value="rut">
                                <Icon size="small" type="idcard" className="icon-select-type-validation"/>
                                {t('forms.manager.validation.rut')}
                            </Select.Option>
                            <Select.Option value="rutNat">
                                <Icon size="small" type="idcard" className="icon-select-type-validation"/>
                                {t('forms.manager.validation.rutNat')}
                            </Select.Option>
                            <Select.Option value="rutEmp">
                                <Icon size="small" type="idcard" className="icon-select-type-validation"/>
                                {t('forms.manager.validation.rutEmp')}
                            </Select.Option>
                            <Select.Option value="number">
                                <Icon size="small" type="number" className="icon-select-type-validation"/>
                                {t('forms.manager.validation.number')}
                            </Select.Option>
                            <Select.Option value="percent">
                                <Icon size="small" type="percentage" className="icon-select-type-validation"/>
                                {t('forms.manager.validation.percent')}
                            </Select.Option>
                        </Select>
                    </Form.Item>
                </Row>
                <Row>
                    <Col span={12}>
                        <Form.Item label={t('forms.manager.validation.maxLength')}>
                            <InputNumber value={maxLength} min={1} max={150} step={1}
                                        onChange={handleChangeMaxLength}
                                        disabled={selectedValue && (selectedValue === 'percent' || selectedValue.startsWith('rut'))}/>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label={t('forms.manager.validation.decimals')}>
                            <InputNumber min={0} max={5} step={1}
                                        disabled={selectedValue !== 'number' && selectedValue !== 'percent'}
                                        value={decimals} onChange={handleChangeDecimals}/>
                        </Form.Item>
                    </Col>
                </Row>
                { component.type !== 'PARAGRAPH' &&
                <>
                    <Divider orientation="left">{t('messages.aml.condition', {ns: 'translations'})}</Divider>
                    <Row>
                        <Col span={12}>
                            <Form.Item label={t('forms.manager.validation.attributeName')}>
                                <Select value={selectedValue && fieldConditionId} disabled={selectedValue === null}
                                        onChange={(val) => handleChangeFieldCondition(val, true)}>
                                    <Select.Option
                                        value={null}>{t('messages.aml.none', {ns: 'translations'})}</Select.Option>
                                    {fields && fields.map(f =>
                                        ["SELECT", "RADIO", "CHECKBOX", "RADIOOTHER"].includes(f.typeField) && f.id !== field.id &&
                                        <Select.Option value={f.id}>{f.title && f.title[lang]}</Select.Option>
                                    )}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label={t('forms.manager.validation.option')}>
                                {(selectedValue && fieldCondition) ?
                                    (
                                        fieldCondition.typeField === "CHECKBOX" ?
                                            <Checkbox checked={fieldConditionValue}
                                                    onChange={(e) => handleChangeValueCondition(e.target.checked)}/>
                                            : fieldCondition.source ?
                                                <Select
                                                    showSearch
                                                    filterOption={(input, option) =>
                                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    value={fieldConditionValue}
                                                    onChange={handleChangeValueCondition}
                                                >
                                                    {getValuesFromDS(fieldCondition).map(val =>
                                                        <Select.Option
                                                            value={val.code}>{val.jsonValue && val.jsonValue[lang]}</Select.Option>
                                                    )}
                                                </Select>
                                                :
                                                <Input value={fieldConditionValue}
                                                    onChange={(e) => handleChangeValueCondition(e.target.value)}/>
                                    )
                                    :
                                    <Input disabled={true}/>
                                }
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider orientation="left">{t('messages.aml.prefill', {ns: 'translations'})}</Divider>
                    <Row>
                        <Col span={12}>
                            <Form.Item label={t('forms.manager.validation.attributeName')}>
                                <Select value={fieldPrefilledId}
                                        onChange={(val) => handleChangeFieldPrefilled(val, true)}>
                                    <Select.Option
                                        value={null}>{t('messages.aml.none', {ns: 'translations'})}</Select.Option>
                                    {fields && fields.map(f =>
                                        ["SELECT"].includes(f.typeField) && f.id !== field.id &&
                                        <Select.Option value={f.id}>{f.title && f.title[lang]}</Select.Option>
                                    )}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label={t('forms.manager.validation.option')}>
                                {(fieldPrefilled) ?
                                    (
                                        fieldPrefilled.typeField === "CHECKBOX" ?
                                            <Checkbox checked={fieldPrefilledValue}
                                                    onChange={(e) => handleChangeValuePrefilled(e.target.checked)}/>
                                            : fieldPrefilled.source ?
                                                <Select
                                                    showSearch
                                                    filterOption={(input, option) =>
                                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    value={fieldPrefilledValue}
                                                    onChange={handleChangeValuePrefilled}
                                                >
                                                    {getValuesFromDS(fieldPrefilled).map(val =>
                                                        <Select.Option
                                                            value={val.code}>{val.jsonValue && val.jsonValue[lang]}</Select.Option>
                                                    )}
                                                </Select>
                                                :
                                                <Input value={fieldPrefilledValue}
                                                    onChange={(e) => handleChangeValuePrefilled(e.target.value)}/>
                                    )
                                    :
                                    <Input disabled={true}/>
                                }
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item label={t('forms.manager.validation.value')}>
                                <Select disabled={!fieldPrefilledId || !fieldPrefilledValue}
                                        value={fieldPrefilledOption} style={{width: '98%'}}
                                        onChange={handleChangeOptionPrefilled}>
                                    <Select.Option value="rut">
                                        {t("messages.aml.rut", {ns: 'translations'})}
                                    </Select.Option>
                                    <Select.Option value="name">
                                        {t("messages.aml.name", {ns: 'translations'})}
                                    </Select.Option>
                                    <Select.Option value="email">
                                        E-mail
                                    </Select.Option>
                                    { currentUser?.cliente?.outsourcer && currentUser?.cliente?.clientes && 
                                        <Select.Option value="company">
                                            {t("messages.aml.subclient", {ns: 'translations'})}
                                        </Select.Option>
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                </>
                }
            </>
            }

            <Row className="tools-validation">
                <Button onClick={closeModalHandler}>{t('forms.manager.validation.close')}</Button>
                <Button type="primary"
                        onClick={handleClickSelectValidation}>{t('forms.manager.validation.apply')}</Button>
            </Row>
        </Row>
    );
};

export default Validation;